import React from 'react';
import { Redirect } from 'react-router-dom';
import ModalEnabled from '../extend/ModalEnabled';
import DetailsBar from '../shared/DetailsBar';
import BackButton from '../shared/BackButton';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import TextAreaView from '../shared/TextAreaView';
import SVGTrash from '../../svg/Trash';
import SVGMail from '../../svg/Mail';
import ServiceClient from './ServiceClient';
import ServiceStaff from './ServiceStaff';
import ServiceCharge from './ServiceCharge';
import { stringfyServerErrors } from '../../helpers/util';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import SkipWeekModal from '../menuSelection/SkipWeekModal';
import Loader from '../shared/Loader';
import {
  maskServiceDate,
  maskServiceStartTime,
  maskServiceEndTime,
  maskPrependComma
} from '../../masks';

class ServiceCustomWeekly extends ModalEnabled {
  state = {
    service: {},
    redirect_to: false,
    isLoading: false
  };

  detailBarProperties = [
    {
      label: 'Date & Time',
      className: 'p',
      combine: [
        { key: 'date', mask: maskServiceDate },
        { raw: ' ', className: '--new-line' },
        { key: 'start_time', mask: maskServiceStartTime },
        { key: 'end_time', mask: maskServiceEndTime }
      ]
    },
    { label: 'Portion Size', key: 'portion_size', className: 'p --capitalize' },
    { label: 'Diet', key: 'client', dive: ['dietary_preference_tags', 'tag'] },
    {
      label: 'Allergens',
      key: 'client',
      combine: [
        { key: 'allergen_tags', dive: 'tag' },
        { key: 'other_allergens', mask: maskPrependComma }
      ]
    }
  ];

  render() {
    const {
      service,
      updateService,
      submitService,
      openModal,
      isClientEdit,
      isStaffEdit,
      sendStaffMail
    } = this.props;

    const { isLoading } = this.state;

    if (isLoading) return <Loader />;

    if (this.state.redirect_to) return <Redirect to={this.state.redirect_to} />;

    return (
      <div className="cms--service">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/admin/services" />
            <div className="cms__bar">
              <HeadingPlaceholder
                value={service.name}
                placeholder="Custom Weekly Service"
                label="Custom Weekly Service"
              />
              <div className="cms__bar-ctas">
                {service.id ? (
                  <div
                    className="btn-icon btn-icon--mail"
                    onClick={() => this.props.openSendDetailsModal()}
                  >
                    <SVGMail />
                  </div>
                ) : (
                  ''
                )}
                {service.id ? (
                  <div
                    className="btn-icon btn-icon--trash"
                    onClick={() => openModal('delete')}
                  >
                    <SVGTrash />
                  </div>
                ) : (
                  ''
                )}
                <div
                  className="btn btn--hollow-blue"
                  onClick={() => openModal('edit-details')}
                >
                  Edit Details
                </div>
                <input
                  type="submit"
                  className="btn btn--solid-blue"
                  value="Save"
                  onClick={() => submitService()}
                />
              </div>
            </div>
            <DetailsBar data={service} columns={this.detailBarProperties} />
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <ServiceClient
              openModal={() => openModal('add-client')}
              isEdit={isClientEdit}
              client={service.client}
              address={service.address}
              updateService={updateService}
            />

            <TextAreaView
              openDishModal={() => openModal('add-dish')}
              openMenuModal={() => openModal('add-menu')}
              value={service.custom_weekly_details}
              openEdit={() => openModal('edit-menu')}
              title="Menu"
            />

            <ServiceStaff
              openAddStaffModal={() => openModal('add-staff')}
              sendStaffMail={sendStaffMail}
              service={service}
              updateService={updateService}
              isEdit={isStaffEdit}
              openSendDetailsModal={staff =>
                this.props.openSendDetailsModal(staff)
              }
            />

            <div className="row">
              <div className="row__item row__item--half row__item--pad-right">
                <ServiceCharge
                  service={service}
                  updateService={updateService}
                />
              </div>
              <div className="row__item row__item--half row__item--pad-left">
                <TextAreaView
                  value={service.notes}
                  openEdit={() => openModal('notes')}
                />
              </div>
            </div>
            {service.id && (
              <div className="row">
                <button
                  type="button"
                  className="btn btn--hollow-red"
                  onClick={() => this.openModal('skip-week')}
                  disabled={service.skipped}
                >
                  Skip Week
                </button>
              </div>
            )}
          </div>
        </div>

        <SkipWeekModal
          isOpen={this.isOpen('skip-week')}
          closeModal={this.closeModal}
          skipWeek={this.handleSkipWeek}
        />
      </div>
    );
  }

  handleSkipWeek = (reason = '') => {
    const { service } = this.state;
    serviceAPI
      .skipService(this.state.service.id, reason)
      .then(res => {
        this.props.addMessage({
          className: 'success',
          message: `"Service: ${service.name}" has been skipped.`
        });
        this.setState({ redirect_to: '/' });
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        });
        this.closeModal();
      });
  };

  loadService(id) {
    this.setState({ isLoading: true });
    serviceAPI
      .getService(id)
      .then(service => this.setState({ service, isLoading: false }))
      .catch(this.handleErrorLoading);
  }

  handleErrorLoading = error => {
    console.log(error);
    const pathname = '/';
    const redirect_to = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        redirect_to.pathname = redirect_url;
      }

      if (redirect_payload) redirect_to.state = { ...redirect_payload };
    }
    this.props.addMessage({
      className: 'error',
      message: stringfyServerErrors(error)
    }); // todo: add messaging
    this.setState({ redirect_to, isLoading: false });
  };

  componentDidMount() {
    const { id = 0 } = this.props.service;
    if (id && id > 0) {
      this.loadService(id);
    }
  }
}
export default ServiceCustomWeekly;



// WEBPACK FOOTER //
// ./src/components/service/ServiceCustomWeekly.js